export const VIEWED_STORY = 'stories::viewed-story';
export const SELECT_STORY = 'stories::select-story';
export const VIEWED_INDEXES_STORAGE_KEY = 'viewedIndexes';
